export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  rating: number;
  category: string;
  tags: string[];
  description: string;
  updateDate: string;
  status: '连载中' | '已完结';
  chapters: number;
  views: number;
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { slug: 'romance', name: '浪漫爱情', icon: 'ri-heart-line', description: '甜蜜浪漫的韩国恋爱漫画推荐' },
  { slug: 'action', name: '热血动作', icon: 'ri-sword-line', description: '高燃战斗的韩国动作漫画推荐' },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line', description: '奇幻世界的韩国冒险漫画推荐' },
  { slug: 'thriller', name: '悬疑推理', icon: 'ri-search-eye-line', description: '扣人心弦的韩国悬疑漫画推荐' },
  { slug: 'slice-of-life', name: '日常治愈', icon: 'ri-sun-line', description: '温暖治愈的韩国日常漫画推荐' },
  { slug: 'drama', name: '剧情深度', icon: 'ri-emotion-line', description: '情节丰富的韩国剧情漫画推荐' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '她的秘密花园',
    author: '金智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20woman%20in%20a%20secret%20garden%20with%20flowers%2C%20soft%20romantic%20atmosphere%2C%20pastel%20colors%2C%20delicate%20linework%2C%20Korean%20webtoon%20art%20style%2C%20dreamy%20lighting%2C%20slightly%20mysterious%20mood%2C%20clean%20composition%20on%20light%20cream%20background&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    rating: 4.8,
    category: 'romance',
    tags: ['恋爱', '都市', '治愈'],
    description: '一个平凡女孩偶然发现了城市中隐藏的秘密花园，在那里遇见了改变她一生的神秘男人。细腻的情感描绘和唯美的画风，让这部作品成为近年最受欢迎的韩国恋爱漫画之一。',
    updateDate: '2026-08-03',
    status: '连载中',
    chapters: 87,
    views: 1250000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-2',
    title: '剑与王冠',
    author: '朴武镇',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20action%20illustration%20of%20a%20warrior%20holding%20a%20sword%20with%20a%20golden%20crown%20in%20the%20background%2C%20epic%20fantasy%20style%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20art%2C%20intense%20expression%2C%20royal%20red%20and%20gold%20color%20scheme%2C%20clean%20composition%20on%20dark%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    rating: 4.6,
    category: 'action',
    tags: ['战斗', '王国', '史诗'],
    description: '在被阴谋笼罩的王国中，一名被流放的骑士踏上夺回王冠的征途。激烈的战斗场面和紧凑的剧情节奏，让读者欲罢不能。',
    updateDate: '2026-08-02',
    status: '连载中',
    chapters: 124,
    views: 980000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-3',
    title: '异世界料理师',
    author: '李美娜',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20fantasy%20illustration%20of%20a%20chef%20in%20a%20magical%20kitchen%20with%20floating%20ingredients%20and%20sparkles%2C%20warm%20cozy%20atmosphere%2C%20Korean%20webtoon%20style%2C%20vibrant%20food%20colors%2C%20soft%20magical%20glow%2C%20clean%20composition%20on%20warm%20beige%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    rating: 4.7,
    category: 'fantasy',
    tags: ['美食', '异世界', '冒险'],
    description: '顶级厨师意外穿越到魔法世界，用现代料理征服异世界居民的胃和心。温暖治愈又充满创意，美食画面令人垂涎。',
    updateDate: '2026-08-03',
    status: '连载中',
    chapters: 56,
    views: 760000,
    isHot: true,
    isNew: true,
  },
  {
    id: 'comic-4',
    title: '第七个目击者',
    author: '崔正宇',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20thriller%20illustration%20of%20a%20detective%20in%20a%20dark%20alley%20with%20rain%2C%20mysterious%20noir%20atmosphere%2C%20Korean%20webtoon%20style%2C%20cool%20blueish%20tones%2C%20dramatic%20shadows%2C%20suspenseful%20mood%2C%20clean%20composition%20on%20dark%20gray%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    rating: 4.5,
    category: 'thriller',
    tags: ['推理', '犯罪', '悬疑'],
    description: '一场看似完美的犯罪，七个目击者却给出了七个截然不同的证词。刑警金泰浩必须在谎言中寻找真相。每章反转令人惊叹。',
    updateDate: '2026-08-01',
    status: '连载中',
    chapters: 42,
    views: 650000,
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-5',
    title: '咖啡与猫',
    author: '尹秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20slice%20of%20life%20illustration%20of%20a%20cozy%20cat%20cafe%20with%20a%20young%20woman%20and%20cats%2C%20warm%20sunlight%2C%20Korean%20webtoon%20style%2C%20soft%20pastel%20colors%2C%20peaceful%20atmosphere%2C%20clean%20composition%20on%20cream%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    rating: 4.9,
    category: 'slice-of-life',
    tags: ['治愈', '猫咪', '日常'],
    description: '在首尔的一条安静小巷里，有一家猫咪咖啡馆。每个来访的客人都带着自己的故事，而猫咪们用温柔的方式治愈着每一颗疲惫的心。',
    updateDate: '2026-08-03',
    status: '已完结',
    chapters: 68,
    views: 1500000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-6',
    title: '逆光而行',
    author: '姜贤宇',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20drama%20illustration%20of%20a%20young%20man%20walking%20against%20sunlight%20in%20a%20city%20street%2C%20emotional%20atmosphere%2C%20Korean%20webtoon%20style%2C%20warm%20golden%20hour%20lighting%2C%20melancholic%20yet%20hopeful%20mood%2C%20clean%20composition&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    rating: 4.4,
    category: 'drama',
    tags: ['成长', '青春', '现实'],
    description: '一个失去梦想的年轻人，在人生的最低谷遇见了让他重新找到方向的人。深刻的人物刻画和真实的情感表达，引发无数读者共鸣。',
    updateDate: '2026-07-30',
    status: '连载中',
    chapters: 95,
    views: 820000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-7',
    title: '月光奏鸣曲',
    author: '金智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20romance%20illustration%20of%20a%20pianist%20under%20moonlight%20with%20musical%20notes%20floating%2C%20elegant%20romantic%20atmosphere%2C%20Korean%20webtoon%20style%2C%20silver%20and%20blue%20toned%2C%20dreamy%20mood%2C%20clean%20composition%20on%20dark%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    rating: 4.7,
    category: 'romance',
    tags: ['音乐', '恋爱', '艺术'],
    description: '天才钢琴少女与落魄音乐制作人的相遇，在月光下的合奏中谱写出动人的爱情乐章。画面如同音乐般流畅优美。',
    updateDate: '2026-08-02',
    status: '连载中',
    chapters: 63,
    views: 890000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-8',
    title: '神之塔：重生',
    author: '郑恩秀',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20fantasy%20action%20illustration%20of%20a%20character%20climbing%20a%20mysterious%20tower%20with%20magical%20energy%2C%20epic%20scale%2C%20Korean%20webtoon%20style%2C%20vibrant%20colors%2C%20dramatic%20perspective%2C%20clean%20composition&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    rating: 4.8,
    category: 'fantasy',
    tags: ['冒险', '战斗', '成长'],
    description: '为了拯救被困在神之塔顶端的亲人，少年踏上攀登塔楼的危险旅程。宏大的世界观和精彩的战斗设计，是奇幻漫画中的佼佼者。',
    updateDate: '2026-08-03',
    status: '连载中',
    chapters: 156,
    views: 2100000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-9',
    title: '午夜诊所',
    author: '崔正宇',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20mystery%20thriller%20illustration%20of%20a%20doctor%20in%20a%20dimly%20lit%20clinic%20at%20night%2C%20eerie%20atmosphere%2C%20Korean%20webtoon%20style%2C%20greenish%20medical%20tones%2C%20suspenseful%20mood%2C%20clean%20composition%20on%20dark%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    rating: 4.6,
    category: 'thriller',
    tags: ['医疗', '悬疑', '超自然'],
    description: '只在午夜营业的神秘诊所，治疗的不仅是身体的疾病，还有灵魂的创伤。每个病例背后都隐藏着令人震惊的秘密。',
    updateDate: '2026-07-28',
    status: '连载中',
    chapters: 38,
    views: 540000,
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-10',
    title: '春天来了',
    author: '尹秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20healing%20illustration%20of%20cherry%20blossoms%20and%20a%20young%20woman%20smiling%20in%20a%20park%2C%20spring%20atmosphere%2C%20Korean%20webtoon%20style%2C%20soft%20pink%20and%20green%20tones%2C%20peaceful%20and%20warm%20mood%2C%20clean%20composition&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    rating: 4.5,
    category: 'slice-of-life',
    tags: ['治愈', '春天', '友情'],
    description: '四个好朋友在春天的约定，关于友情、成长和重新开始的温暖故事。每一话都像春风一样轻柔地抚慰读者的心灵。',
    updateDate: '2026-08-01',
    status: '已完结',
    chapters: 52,
    views: 720000,
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-11',
    title: '暗影猎手',
    author: '朴武镇',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20action%20illustration%20of%20a%20shadow%20hunter%20with%20dark%20powers%20in%20an%20urban%20setting%2C%20dynamic%20pose%2C%20Korean%20webtoon%20style%2C%20dark%20purple%20and%20black%20tones%2C%20intense%20energy%2C%20clean%20composition&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    rating: 4.3,
    category: 'action',
    tags: ['超能力', '都市', '战斗'],
    description: '在普通人类不知晓的暗影世界中，猎手们守护着两个世界的平衡。精彩的动作设计和独特的超能力体系让人眼前一亮。',
    updateDate: '2026-07-31',
    status: '连载中',
    chapters: 78,
    views: 610000,
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-12',
    title: '画中仙',
    author: '李美娜',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20historical%20fantasy%20illustration%20of%20a%20beautiful%20woman%20in%20traditional%20hanbok%20emerging%20from%20a%20painting%2C%20ethereal%20atmosphere%2C%20Korean%20webtoon%20style%2C%20ink%20wash%20painting%20aesthetic%2C%20soft%20colors%2C%20clean%20composition&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    rating: 4.9,
    category: 'drama',
    tags: ['古风', '奇幻', '爱情'],
    description: '一幅古代仕女图中的仙女因缘际会来到现代，与一名美术修复师展开跨越时空的奇妙缘分。画风融合传统水墨美学与现代漫画技法，令人惊艳。',
    updateDate: '2026-08-03',
    status: '连载中',
    chapters: 45,
    views: 1050000,
    isHot: true,
    isNew: false,
  },
];

export const getComicsByCategory = (slug: string): Comic[] => {
  return comics.filter((c) => c.category === slug);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getHotComics = (): Comic[] => {
  return comics.filter((c) => c.isHot);
};

export const getNewComics = (): Comic[] => {
  return comics.filter((c) => c.isNew);
};